import { theme } from '@/styles';
import Image from '@/ui/Image';
import { getAsset } from '@/utils';
import React from 'react';
import styled from 'styled-components';

const IC_EMPTY_56 = '/assets/icons/ic_empty_56.svg';
const IC_EMPTY_72 = '/assets/icons/ic_empty_72.svg';

interface ErrorMessagePropsType {
  size?: 'm' | 'l';
  title?: string;
  subTitle?: string;
}

const ErrorMessage = ({
  size = 'm',
  title,
  subTitle,
}: ErrorMessagePropsType) => {
  return (
    <ErrorMessageWrapper>
      <Image
        src={size === 'l' ? getAsset(IC_EMPTY_72) : getAsset(IC_EMPTY_56)}
        width={size === 'l' ? 72 : 56}
        height={size === 'l' ? 72 : 56}
        alt={size === 'l' ? getAsset(IC_EMPTY_72) : getAsset(IC_EMPTY_56)}
      />
      <TitleText size={size}>{title}</TitleText>
      {subTitle && <SubTitleText>{subTitle}</SubTitleText>}
    </ErrorMessageWrapper>
  );
};

export default ErrorMessage;

const ErrorMessageWrapper = styled.div`
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TitleText = styled.p<{ size?: 'm' | 'l' }>`
  ${theme.typography.body1};
  width: fit-content;
  white-space: pre-wrap;
  margin-top: ${({ size }) => (size === 'l' ? 24 : 12)}px;
  text-align: center;
`;

const SubTitleText = styled.p`
  ${theme.typography.caption1};
  width: fit-content;
  white-space: pre-wrap;
  margin-top: 8px;
  text-align: center;
  color: ${theme.colors.neutral_colors.gray[700]};
`;
